<template>
  <div class="details-item">
    <h3 class="details-item__label-row">
      <span class="details-item__label-text">
        <Skeleton v-if="isLoading" width="120px" height="24px" />
        <template v-else>{{ label }}</template>
      </span>
      <span class="details-item__label-right">
        <slot name="label-right" />
      </span>
    </h3>
    <div class="details-item__divider" />
    <div class="details-item__value">
      <Skeleton v-if="isLoading" width="80%" height="20px" />
      <slot v-else name="value">
        {{ value || "-" }}
      </slot>
    </div>
  </div>
</template>

<script setup lang="ts">
import Skeleton from "primevue/skeleton";

defineProps({
  label: { type: String, required: true },
  value: { type: [String, Number, Date, Object], default: null },
  isLoading: { type: Boolean, default: false },
});
</script>

<style lang="scss" scoped>
.details-item {
  display: flex;
  flex-direction: column;
  gap: 8px;

  &__label-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0;
  }

  &__label-text {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 16px;
    font-weight: 600;
    color: #1d1d1d;
  }

  &__label-right {
    display: flex;
    align-items: center;
    margin-left: 12px;
    margin-top: -12px;
  }

  &__divider {
    height: 1px;
    background: #dfcfe5;
    margin-bottom: 8px;
  }

  &__value {
    font-size: 14px;
    font-weight: 400;
    color: #1d1d1d;
    margin: 0;
  }
}
</style>
